/* FREE SPEECH Basics: garment measurements, XXS to 5XL. See docs/size-spec.md in the project. */

window.FS = window.FS || {};

/* Garment measurements in inches, laid flat.
   XS–3XL are the factory sheet's. XXS, 4XL and 5XL are graded: each continues
   the step of its nearest pair on the sheet (see docs/size-spec.md). */
FS.sizes = {
  order: ["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL"],
  graded: ["XXS", "4XL", "5XL"],
  points: [
    { id: "length", name: "Body length from HPS", short: "Length", key: "B", tol: 0.5,
      values: [26.5, 27.5, 28.5, 29.5, 30.5, 31.5, 32.5, 33.5, 34.5, 35.5] },
    { id: "chest", name: "Chest width, 1″ below armhole", short: "Chest", key: "A", tol: 0.5,
      values: [19, 20, 21, 22, 23.5, 25, 26.5, 28, 29.5, 31] },
    { id: "shoulder", name: "Across shoulder, seam to seam", short: "Shoulder", key: "C", tol: 0.5,
      values: [15.5, 16.5, 17.5, 18.5, 19.5, 20.5, 21.5, 22.5, 23.5, 24.5] },
    { id: "front", name: "Across front, 7″ down from HPS", tol: 0.5,
      values: [13.5, 14.5, 15.5, 16.5, 17.5, 18.5, 19.5, 20.5, 21.5, 22.5] },
    { id: "back", name: "Across back, 7″ down from HPS", tol: 0.5,
      values: [14.5, 15.5, 16.5, 17.5, 18.5, 19.5, 20.5, 21.5, 22.5, 23.5] },
    { id: "armhole", name: "Armhole straight, seam to seam", tol: 0.25,
      values: [8.5, 8.75, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5] },
    { id: "opening", name: "Sleeve opening", tol: 0.25,
      values: [6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5] },
    { id: "sleeve", name: "Sleeve length from centre back neck", short: "Sleeve", key: "D", tol: 0.25,
      values: [18.75, 19.5, 19.75, 20.5, 21.25, 22, 22.75, 23.5, 24.25, 25] },
    { id: "neck", name: "Neck width, HPS to HPS", tol: 0.25,
      values: [6.25, 6.5, 6.75, 7, 7.25, 7.5, 7.75, 8, 8.25, 8.5] },
    { id: "drop", name: "Front neck drop from HPS", tol: 0.25,
      values: [3.25, 3.5, 3.75, 4, 4.25, 4.5, 4.75, 5, 5.25, 5.5] }
  ],
  /* The short chart: the four measurements people compare. */
  short: ["chest", "length", "shoulder", "sleeve"]
};
